import { ptzaModulesManager } from './ui/modules/modules-manager.js';
import ptzaRender, { PTZA_COMPONENTS } from '../src/ui/extras/renderApp.js';

window.PTZA = {
    config: null,
    modules: null
};

document.addEventListener('DOMContentLoaded', async () => {
    if (!await initRender()) return false;
    await initConfig();    
    await initModules();
});

async function initConfig(){
    const { ptzaConfig } = await import('./controllers/config.js');
    window.PTZA.config = ptzaConfig;
    await window.PTZA.config.loadConfig();
}

async function initModules(){
    await ptzaModulesManager.init();
}

async function initRender() {
    if (!ptzaRender) {
        console.error('[PTZA Core] No se pudo cargar ptzaRender.');
        return false;
    }

    if (typeof ptzaRender.mountAll !== 'function') {
        console.error('[PTZA Core] ptzaRender.mountAll no está disponible.');
        return false;
    }

    if (!PTZA_COMPONENTS || typeof PTZA_COMPONENTS !== 'object') {
        console.error('[PTZA Core] PTZA_COMPONENTS no está disponible.');
        return false;
    }

    await ptzaRender.mountAll(document);
    return true;
}